import type { MbtilesEntry } from '../../api/types';
import type { AccessMode } from './shared';

interface Props {
  baseUrl: string;
  onChangeBaseUrl: (b: string) => void;
  mbtiles: MbtilesEntry[] | null;
  selectedId: string;
  onSelectId: (id: string) => void;
  mode: AccessMode;
  onChangeMode: (m: AccessMode) => void;
  token: string;
  onChangeToken: (t: string) => void;
}

/**
 * 두 데모 페이지가 공유하는 상단 컨트롤바.
 * - mbtiles 선택
 * - public / read-token 모드 토글
 * - read-token JWT 직접 입력 (서버는 plain JWT를 발급 직후 1회만 노출하므로 사용자가 붙여넣기)
 */
export function ExampleControls({
  baseUrl,
  onChangeBaseUrl,
  mbtiles,
  selectedId,
  onSelectId,
  mode,
  onChangeMode,
  token,
  onChangeToken,
}: Props) {
  return (
    <div className="card">
      <h3>설정</h3>
      <div className="row" style={{ marginBottom: '0.75rem' }}>
        <label style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flex: 1 }}>
          API base URL
          <input
            type="text"
            value={baseUrl}
            onChange={(e) => onChangeBaseUrl(e.target.value)}
            placeholder="예: http://localhost:8090"
            style={{ flex: 1, minWidth: 240, fontFamily: 'ui-monospace, monospace' }}
            data-testid="example-base-url"
          />
        </label>
      </div>
      <div className="row" style={{ marginBottom: '0.75rem' }}>
        <label style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          mbtiles
          <select
            value={selectedId}
            onChange={(e) => onSelectId(e.target.value)}
            data-testid="example-mbtiles-select"
          >
            {!mbtiles && <option>로딩 중…</option>}
            {mbtiles && mbtiles.length === 0 && <option>등록된 mbtiles 없음</option>}
            {mbtiles?.map((m) => (
              <option key={m.id} value={m.id}>
                {m.displayName || m.id} {m.public ? '(public)' : '(private)'}
              </option>
            ))}
          </select>
        </label>

        <label style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          <input
            type="radio"
            name="mode"
            checked={mode === 'public'}
            onChange={() => onChangeMode('public')}
            data-testid="example-mode-public"
          />
          public (토큰 없이)
        </label>

        <label style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          <input
            type="radio"
            name="mode"
            checked={mode === 'token'}
            onChange={() => onChangeMode('token')}
            data-testid="example-mode-token"
          />
          read-token
        </label>
      </div>

      {mode === 'token' && (
        <div className="row">
          <input
            type="text"
            value={token}
            onChange={(e) => onChangeToken(e.target.value)}
            placeholder="발급받은 read-token JWT 붙여넣기"
            style={{ flex: 1, minWidth: 320, fontFamily: 'ui-monospace, monospace' }}
            data-testid="example-token-input"
          />
        </div>
      )}

      <div style={{ fontSize: '0.85rem', color: '#6b7280', marginTop: '0.5rem' }}>
        선택한 mbtiles가 private인데 public 모드로 보면 401이 정상입니다.
        read-token 의 plain JWT는 발급 직후 한 번만 노출되므로 그때 받아둔 값을 직접
        붙여넣어 주세요.
      </div>
    </div>
  );
}
